export const Technologie = [
  {
    id: "1",
    title: "html",
    imgPath: "./images/technologiev1/html.svg",
  },
  {
    id: "2",
    title: "css",
    imgPath: "./images/technologiev1/css.svg",
  },

  {
    id: "5",
    title: "bootstrap",
    imgPath: "./images/technologiev1/bootstrap.svg",
  },

  {
    id: "11",
    title: "Tailwind CSS",
    imgPath: "./images/technologiev1/tailwand.svg",
  },
  {
    id: "6",
    title: "javascript",
    imgPath: "./images/technologiev1/javascript.svg",
  },
  {
    id: "5",
    title: "reactJs",
    imgPath: "./images/technologiev1/reactJs.svg",
  },
  {
    id: "10",
    title: "nextJs",
    imgPath: "./images/technologiev1/NextJs.svg",
  },
  {
    id: "5",
    title: "ionic",
    imgPath: "./images/technologiev1/ionic.svg",
  },
  {
    id: "3",
    title: "adobe photoshop",
    imgPath: "./images/technologiev1/Adobe_Photoshop_CC_icon.svg",
  },
  {
    id: "5",
    title: "adobe illustrator",
    imgPath: "./images/technologiev1/illust.svg",
  },
  {
    id: "7",
    title: "figma",
    imgPath: "./images/technologiev1/figma.svg",
  },
  {
    id: "4",
    title: "android studio",
    imgPath: "./images/technologiev1/android studio.svg",
  },
  {
    id: "6",
    title: "dart",
    imgPath: "./images/technologiev1/DART.svg",
  },

  {
    id: "8",
    title: "flutter",
    imgPath: "./images/technologiev1/FLUTTER.svg",
  },
  {
    id: "5",
    title: "git",
    imgPath: "./images/technologiev1/git.svg",
  },
  {
    id: "5",
    title: "github",
    imgPath: "./images/technologiev1/github.svg",
  },

  {
    id: "5",
    title: "mysql",
    imgPath: "./images/technologiev1/mysql.svg",
  },
  {
    id: "6",
    title: "laragon",
    imgPath: "./images/technologiev1/laragon.png",
  },
  {
    id: "5",
    title: "php",
    imgPath: "./images/technologiev1/php.svg",
  },
  {
    id: "5",
    title: "laravel",
    imgPath: "./images/technologiev1/laravel.svg",
  },
  {
    id: "5",
    title: "vscode",
    imgPath: "./images/technologiev1/vscode.svg",
  },
  {
    id: "5",
    title: "wordpress",
    imgPath: "./images/technologiev1/wordpress.svg",
  },
 
];
